import * as validators from "vuelidate/lib/validators"
import { regex } from "vuelidate/lib/validators/common"

export const between = validators.between
export const email = validators.email
export const integer = validators.integer
export const minLength = validators.minLength
export const maxLength = validators.maxLength
export const minValue = validators.minValue
export const required = validators.required
export const requiredIf = validators.requiredIf

// custom decimal validator to support scientific notation
export const decimal = regex("decimal", /^[-]?\d*(\.\d+)?([eE][-+]?\d+)?$/)

export const ipfsHash = regex("ipfsHash", /^Qm[1-9A-HJ-NP-Za-km-z]{44}$/)
export const shaHash = regex("shaHash", /^0x[0-9A-Fa-f]{64}$/)
export const ethAddress = regex("ethAddress", /^0x[a-fA-F0-9]{40}$/)

// no numbers or most special characters on english qwerty keyboard
export const name = regex("name", /^[^0-9~!@#$%^&*()_+`={}|[\]\\:";<>?/]+$/)
